import Vue from 'vue'
import Vuex from 'vuex'

import accounting from 'accounting'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    lifeExpData: null,
    GDPData: null,
    result: null,
    interest: 0.03,
    salesPercentCost: 1.5,
    adminCostDuringPayments: 0.20,
    selectedCurrentAge: 40,
    selectedAgePaymentsStart: 65,
    selectedCountry: 'Ghana',
    selectedGender: 'female',
    annualPayments: 1000,
    yearlyAmountAs: 'percent',
    percentOfGDP: 0.2,
    reserveCapRate: 0,
    useLifeExpectancy: true,
    ageOfDeath: 67
  },
  getters: {
    interest: state => state.interest,
    salesPercentCost: state => state.salesPercentCost,
    adminCostDuringPayments: state => state.adminCostDuringPayments,
    adminCostOutsidePayements: state => state.adminCostDuringPayments * 0.25,
    selectedCurrentAge: state => state.selectedCurrentAge,
    selectedAgePaymentsStart: state => state.selectedAgePaymentsStart,
    selectedCountry: state => state.selectedCountry,
    selectedGender: state => state.selectedGender,
    countryGDP: (state, getters) => getters.getGDP(state.selectedCountry),
    annualPayments: (state, getters) => {
      return state.yearlyAmountAs == 'percent'
        ? getters.getGDP(state.selectedCountry)*state.percentOfGDP
        : state.annualPayments
    },
    reserveCapRate: (state)=>state.reserveCapRate,
    yearlyPaymentInfo: (state, getters) => ({
      yearlyAmountAs: state.yearlyAmountAs,
      annualPayments: state.annualPayments,
      percentOfGDP: state.percentOfGDP,
      selectedCountry: state.selectedCountry,
      countryGDP: getters.getGDP(state.selectedCountry),
      annualPaymentsAsPercentOfGDP: getters.getGDP(state.selectedCountry)*state.percentOfGDP
    }),
    useLifeExpectancy: (state) => state.useLifeExpectancy,
    yearlyAmountAs: (state) => state.yearlyAmountAs,
    countries: state => {
      if (state.lifeExpData == null) return []
      if (state.GDPData == null) return []
      var countries = []
      return state.lifeExpData.filter(row => {
        if (countries.includes(row[0])) return false
        countries.push(row[0])
        return true
      }).map(row=>row[0]).filter(country=>{
          return state.GDPData.map(row=>row[0]).includes(country)
        })
    },
    lifeExpectancy: state => {
      if (state.useLifeExpectancy && state.lifeExpData != null) {
        var statsMF = state.lifeExpData
        .filter(row => row[0] == state.selectedCountry)
        .filter(row => row[1] == state.selectedCurrentAge.toString())
        if (statsMF[0] ==  undefined) {
          return undefined
        }
        return state.selectedGender == 'male'
          ? parseFloat(statsMF[0][2])
          : parseFloat(statsMF[0][3]).toFixed(0)
      } else {
        return state.ageOfDeath
      }
    },
    getGDP: state => (country) => {
      if (state.GDPData == null) return null
      return state.GDPData.filter(row=>row[0] == country)[0][1]
    },
    result: state => state.result
  },
  mutations: {
    setReserveCapRate(state, value) {
      state.reserveCapRate = value
    },
    setAgeOfDeath(state, value) {
      state.ageOfDeath = value
    },
    setUseLifeExpectancy(state, value) {
      state.useLifeExpectancy = value
    },
    setYearlyAmountAs(state, value) {
      state.yearlyAmountAs = value
    },
    setPercentOfGDP(state, value) {
      state.percentOfGDP = value
    },
    setAnnualPaymentAmount(state, value) {
      state.annualPayments = value
    },

    setInterest(state, value) {
      state.interest = value
    },
    setSalesPercentCost(state, value) {
      state.salesPercentCost = value
    },
    setAdminCostDuringPayments(state, value) {
      state.adminCostDuringPayments = value
    },
    setSelectedCurrentAge(state, value){
      state.selectedCurrentAge = value
    },
    setSelectedAgePaymentsStart(state, value){
      state.selectedAgePaymentsStart = value
    },
    setSelectedCountry(state, value){
      state.selectedCountry = value
    },
    setSelectedGender(state, value){
      state.selectedGender = value
    },
    setlifeExpData (state, lifeExpData) {
      var country = ''
      lifeExpData.forEach(row=> row[0] != '' ? country = row[0] : row[0] = country)
      state.lifeExpData = lifeExpData
    },
    setGDPData (state, GDPData) {
      state.GDPData = GDPData
        .filter(row => row[1]!='#N/A')
        .map(row => [row[0], accounting.unformat(row[1])])
    },
    setResult (state, result) {
      state.result = result
    }
  }
})
